import React from "react";
import { useState, useEffect } from "react";
import { FaUserCog } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import { PiListBulletsFill } from "react-icons/pi";
import { HiMiniChatBubbleLeftRight } from "react-icons/hi2";
import { FaRegImages } from "react-icons/fa";
import { IoMdTrophy } from "react-icons/io";
import { IoBriefcaseSharp } from "react-icons/io5";
import { FaBusinessTime } from "react-icons/fa6";
import { FaMapMarkedAlt } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import en from "../language/En";
import ar from "../language/Ar";
function DropdownSalon({ isOpen, openDropdown, toggleDropdown }) {
  const { translations } = useSelector((state) => state.language);
  const location = useLocation();

  const isActive =
    location.pathname === "/salon-list" ||
    location.pathname === "/salon-request";

  // Auto open on route
  useEffect(() => {
    if (isActive) {
      toggleDropdown("salons");
    }
  }, [location.pathname]);

  return (
    <div className="w-full">
      {/* Header button */}
      <button
        onClick={() =>
          toggleDropdown(openDropdown === "salons" ? null : "salons")
        }
        className={`flex items-center gap-2 py-2 text-white w-full ${
          isOpen ? "justify-start pl-12 pr-4" : "justify-center"
        } hover:bg-gray-700`}
      >
        <FaUserCog className={isOpen ? "" : "text-xl"} />
        {isOpen && <span>{translations.sidebar.salons}</span>}
        {isOpen && (
          <IoIosArrowDown
            className={`transition-transform duration-300 ${
              openDropdown === "salons" ? "rotate-180" : ""
            } rtl:ml-0 rtl:mr-auto ltr:ml-auto`}
          />
        )}
      </button>

      {/* Dropdown Items */}
      {openDropdown === "salons" && (
        <ul className="space-y-2 w-full mx-0 px-0 list-none">
          <li>
            <Link
              to="/salon-list"
              className={`flex items-center gap-2 py-2 text-white w-full no-underline hover:bg-gray-700 ${
                isOpen ? "pl-16 pr-4" : "justify-center"
              } ${location.pathname === "/salon-list" ? "bg-[#5A189A]" : ""}`}
            >
              <PiListBulletsFill className={isOpen ? "" : "text-xl"} />
              {isOpen && <span>{translations.sidebar.salons}</span>}
            </Link>
          </li>
          <li>
            <Link
              to="/salon-request"
              className={`flex items-center gap-2 py-2 text-white w-full no-underline hover:bg-gray-700 ${
                isOpen ? "pl-16 pr-4" : "justify-center"
              } ${
                location.pathname === "/salon-request" ? "bg-[#5A189A]" : ""
              }`}
            >
              <PiListBulletsFill className={isOpen ? "" : "text-xl"} />
              {isOpen && <span>{translations.sidebar.salonRequests}</span>}
            </Link>
          </li>

          {/* 
          <li className="w-full">
            <Link
              to="#"
              className="flex items-center gap-2 w-full py-2 px-4 hover:text-green-900 hover:bg-gray-100 text-black no-underline"
            >
              <IoMdTrophy className="text-lg" />
              <span>Awards</span>
            </Link>
          </li> */}
          {/* <li className="w-full">
            <Link
              to="#"
              className="flex items-center gap-2 w-full py-2 px-4 hover:bg-gray-700 text-white no-underline"
            >
              <IoBriefcaseSharp className="text-lg" /> <span>Experiences</span>
            </Link>
          </li>
          <li className="w-full">
            <Link
              to="#"
              className="flex items-center gap-2 w-full py-2 px-4 hover:bg-gray-700 text-white no-underline"
            >
              <FaBusinessTime className="text-lg" />
              <span>Availability Hours</span>
            </Link>
          </li>
          <li className="w-full">
            <Link
              to="#"
              className="flex items-center gap-2 w-full py-2 px-4  hover:bg-gray-700 text-white no-underline"
            >
              <FaMapMarkedAlt className="text-lg" />
              <span>Addresses</span>
            </Link>
          </li> */}
        </ul>
      )}
    </div>
  );
}

export default DropdownSalon;
